import React from 'react';
import moment from 'moment';
import { maintenanceStatuses, maintenanceTimeInMinutes } from '../core/maintenance-constants';

type TimeConverterType = 'dashboard' | 'simulator';

export const digitLength = (num: number): string | number => {
  const strNumber = num.toString().length;
  if (strNumber === 1) return `0${num}`;
  return num;
};
export const secondsConverter = (seconds: number): React.ReactElement => {
  let secs = seconds;
  let minutes = Math.floor(secs / 60);
  secs %= 60;
  const hours = Math.floor(minutes / 60);
  minutes %= 60;
  return (
    <>
      {digitLength(hours)}:{digitLength(minutes)} hours
    </>
  );
};

export const millisecondConverter = (
  milliseconds: number,
  format: TimeConverterType = 'simulator'
): React.ReactElement => {
  let ms = milliseconds;
  let seconds = Math.floor(ms / 1000);
  ms %= 1000;
  let minutes = Math.floor(seconds / 60);
  seconds %= 60;
  let hours = Math.floor(minutes / 60);
  minutes %= 60;

  if (format === 'dashboard') {
    return (
      <>
        {hours}h {digitLength(minutes)}m
      </>
    );
  }

  const days = Math.floor(hours / 24);
  hours %= 24;

  return (
    <>
      {days > 0 && `${days} days, `}
      {digitLength(hours)}:{digitLength(minutes)}:{digitLength(seconds)} hours
    </>
  );
};

export const parseDate = (date: string): React.ReactElement => {
  const dateFormat = 'DD/MM/YYYY';
  const today = moment();
  const lastVisited = moment(date);
  const diff = Math.abs(today.diff(lastVisited, 'days')) + 1;
  const dayLabel = diff === 1 ? 'day' : 'days';
  return (
    <>
      {/* eslint-disable-next-line no-nested-ternary */}
      {diff <= 3 && diff > 0
        ? `${diff} ${dayLabel} ago`
        : diff === 0
        ? 'Today'
        : moment(date).local().format(dateFormat)}
    </>
  );
};

export const getMaintenanceStatus = (maintenanceDate: string): string => {
  const today = moment();
  const maintenanceDateFormatted = moment(maintenanceDate);
  const timeUntilMaintenanceInHours = maintenanceDateFormatted.diff(today, 'hours');
  const timeUntilMaintenanceInMinutes = maintenanceDateFormatted.diff(today, 'minutes');

  // if the maintenance is not within 24 hours or it has passed more then 15 minutes since the maintenance started, ignore the logic
  if (timeUntilMaintenanceInHours >= 24 || timeUntilMaintenanceInMinutes <= -maintenanceTimeInMinutes)
    return maintenanceStatuses.notScheduled;

  // if maintenance is in progress
  // since timeUntilMaintenanceInMinutes will be 0 both the minute before the scheduled maintenance and
  // the minute after, we use <= here, even though the maintence is techniqually not in progress until the value is negative
  if (timeUntilMaintenanceInMinutes <= 0) return maintenanceStatuses.inProgress;

  // if maintenance is within 5mins
  if (timeUntilMaintenanceInMinutes < 5) return maintenanceStatuses.inFiveMinutes;

  // if maintenance is within 15mins
  if (timeUntilMaintenanceInMinutes < 15) return maintenanceStatuses.inFifteenMinutes;

  // if maintenance is within an hour
  if (timeUntilMaintenanceInMinutes < 60) return maintenanceStatuses.withinHour;

  // if non of the above, then maintenance is within a day
  return maintenanceStatuses.withinDay;
};
